import { render, staticRenderFns } from "./ReportTemplate2Item.vue?vue&type=template&id=f75384d0&"
import script from "./ReportTemplate2Item.vue?vue&type=script&lang=js&"
export * from "./ReportTemplate2Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports